export enum CouponType {
  PERCENT = 'PERCENT',
  AMOUNT = 'AMOUNT'
}
